import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { TrialSuccess } from '../../Common/TrialSuccess'

export const ClientQueriesSuccess: FC = () => {
  const navigate = useNavigate()

  return <TrialSuccess buttonLabel='Go to Client Queries now' onButtonClick={() => navigate('/cross-client')} />
}
